export const EnforceOfficeDashboardV2 = 'ARF-881-enforce-office-dashboard-v2';
export const EnforcePaymentHistoryTable = 'ARF-949-enforce-update-payment-history-table';
export const ShiftRequestRedesign =
  'TEMP-15776-shift-request-re-design-the-shift-request-flow-dental-portal';
export const TnCOffices =
  'TEMP-15427-tnc-offices';
export const ShowAchAuthorizationPopup = 'show-ach-authorization-popup';
export const EnablePermSessionRecording = 'ARF-1725-enable-perm-session-recording-dental-portal';
export const EnableSignUpSessionRecording = 'TEMP-16399-enable-signup-session-recording-dental-portal';
export const EnforcePostAJobFunnelImprovements = 'ARF-1884-post-a-job-funnel-improvements';
export const DashboardPermNewBadge = 'ARF-1799-dashboard-perm-new-badge';
